
import React, { useEffect, useState } from "react";
import { ProjectsData } from "../../Assets/resource/project.js";
import { Link } from "react-router-dom";

export default function Projects() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [filterProject, setFilterProject] = useState([]);

  useEffect(() => {

    // const categories = [...new Set(ProjectsData.map((p) => p.category))];
    // const proByCat = categories.map(cat => ({
    //   category: cat,
    //   items: ProjectsData.filter(p => p.category == cat).slice(0,3)
    // }))

    let filter;
      // selectedCategory === "all"
      //   ? ProjectsData
      //   : ProjectsData.filter((p) => p.category === selectedCategory);
    
    if (selectedCategory == 'all') {
      const uniqueCat = ["uiux", "fullstack", "frontend"];
      filter = uniqueCat.flatMap(cat => ProjectsData.filter(p => p.category == cat).slice(0, 3))
      setFilterProject(filter);
    } else {
      filter = ProjectsData.filter(p => p.category == selectedCategory).slice(0, 3)
      setFilterProject(filter)
    }
    
    // if (selectedCategory === "all") {
    //   setFilterProject(ProjectsData);
    // } else {
    //    const filter = ProjectsData.filter(p => {
    //     p.category === selectedCategory;
    //   });
    //   setFilterProject(filter);
    // }

    
  }, [selectedCategory]);

  return (
    <section id="projects" className="w-[90%] md:w-[80%] mx-auto pt-8 pb-24">
      <div className="flex justify-between items-start mt-16 mb-8">
        <div>
          <h3 className="text-[#fbfbff] mb-[40px] md:mb-[48px] text-[36px] md:text-[48px] mb-10 font-regular">
            Featured Project
          </h3>
          <h4 className="mb-[20px] text-[18px] md:text-[20px] md:w-[80%] font-regular text-[#fdfdfd]">
            I have been designing & developing a few of websites and
            applications that showcase my passion and expertise in design &
            development field. Here you will see first 3 projects from each. For
            more please
            <Link
              to="/project/all"
              className="ml-[3px] text-blue-600/80 hover:text-blue-700/80 font-normal hover:underline"
            >
              Explore Projects
              <span className="inline-block ml-1"> &#8594;</span>
            </Link>
          </h4>
        </div>
      </div>
      {/* Project type/tags */}
      <div className="mb-8">
        <ul className="flex gap-[4px] md:gap-4 text-[11px] md:text-[13px] text-gray-300/90">
          <li
            className={`${
              selectedCategory == "all" && "bg-blue-600/80 text-white"
            } px-[8px] md:px-4 py-1 text-[14px] md:text-[18px] border border-slate-700 rounded-full cursor-pointer hover:bg-blue-600/80 hover:text-white`}
            onClick={() => setSelectedCategory("all")}
          >
            All
          </li>
          <li
            onClick={() => setSelectedCategory("uiux")}
            className={`${
              selectedCategory == "uiux" && "bg-blue-600/80 text-white"
            } px-[8px]  md:px-4 py-1 text-[14px] md:text-[18px] border border-slate-700 rounded-full cursor-pointer hover:bg-blue-600/80 hover:text-white`}
          >
            UI & UX
          </li>
          <li
            onClick={() => setSelectedCategory("frontend")}
            className={`${
              selectedCategory == "frontend" && "bg-blue-600/80 text-white"
            } px-[8px]  md:px-4 py-1 text-[14px] md:text-[18px] border border-slate-700 rounded-full cursor-pointer hover:bg-blue-600/80 hover:text-white`}
          >
            Frontend
          </li>
          <li
            onClick={() => setSelectedCategory("fullstack")}
            className={`${
              selectedCategory == "fullstack" && "bg-blue-600/80 text-white"
            } px-[8px] md:px-4 py-1 text-[14px] md:text-[18px] border border-slate-700 rounded-full cursor-pointer hover:bg-blue-600/80 hover:text-white`}
          >
            Full Stack
          </li>
        </ul>
      </div>

      {/* Projects */}
      <div className="my-8 grid md:grid-cols-3 gap-x-6 gap-y-10 grid-cols-1">
        {/* {/*----single project 4----- */}
        {/* {console.log(filterProject.length)} */}
        {filterProject?.map((p) => (
          <div className="w-full border-[#28282b] px-2 py-3 md:px-5 md:py-5 text-[#DEDEDE] relative bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20 rounded-xl text-[#9F9FA8] hover:border-[#1E3A8A]/40 hover:shadow hover:shadow-[#1E3A8A]/90">
            <img
              className="w-full h-[210px] shadow-xl p-[1px] rounded-lg"
              src={p.img}
              alt=""
            />
            <a href={p.liveLink} target="_blank">
              <h3
                title={p.title}
                className="text-[24px] md:text-[26px] mt-[16px] mb-[12px] font-regular text-[#f1f1f1] hover:text-blue-500 line-clamp-1 leading-[1.2] px-1 md:px-0"
              >
                {p.title}
              </h3>
            </a>
            <div className="bg-slate-600/90 w-[100px] text-[15px] absolute top-0 right-0 px-1 py-1 rounded-tr-lg rounded-bl-lg text-white text-center border-violet-400/20 border ">
              {p.category == "uiux" && "UI & UX"}
              {p.category == "frontend" && "Frontend"}
              {p.category == "fullstack" && "Full-Stack"}
            </div>
            <div>
              <ol className="text-[16px] leading-6 text-left block text-gray-300/90">
                <li className="block text-left line-clamp-3 px-1 md:px-0">
                  {p.description}
                </li>
              </ol>

              {/*------PROJECT LIVE LINKS BUTTONS----- */}
              {/*------PROJECT LIVE LINKS BUTTONS----- */}
              <div
                className={`${p?.backLinkGit && ""}
                    gap-2 md:mt-7 mt-8 px-1 md:px-0 pb-2 md:pb-0`}
              >
                {p.liveLink && (
                  <a
                    href={p.liveLink}
                    target="_blank"
                    className="w-full flex justify-center items-center gap-4 md:px-4 px-[10px] py-2.5 rounded-lg border border-slate-700 inline-block border-violet-400/20 bg-slate-600/80 hover:bg-blue-600/80 mb-2 text-[15px] md:text-[16px] text-center text-[#f1f1f1] font-semibold"
                  >
                    <span className="">
                      {p.category == "uiux" ? "Figma Design" : "Live Visit"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M5.576 13.481a3.5 3.5 0 0 0 4.95 4.95m2.473-7.423a3.5 3.5 0 0 1 0 4.95l-2.475 2.475m-2.475-7.425l-2.475 2.475m12.857-2.957a3.5 3.5 0 1 0-4.95-4.95M11.01 13a3.5 3.5 0 0 1 0-4.95l2.474-2.475M15.958 13l2.475-2.475"
                        stroke-width="1.5"
                      />
                    </svg>
                  </a>
                )}

                <div
                  className={`${
                    p?.backLinkGit && "grid md:grid-cols-2 gap-2"
                  } w-full`}
                >
                  {p?.dribble && (
                    <a
                      href={p?.dribble}
                      target="_blank"
                      className="md:px-4 w-full px-[10px] py-2.5 rounded-lg inline-block border border-slate-700 border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1] flex gap-5 items-center justify-center"
                    >
                      <span>{p?.dribble && "Dribble Shot"}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 14 14"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        >
                          <path d="M7 13.25c4 0 6.25-2.25 6.25-6.25S11 .75 7 .75S.75 3 .75 7S3 13.25 7 13.25" />
                          <path d="M1.978 11.175c2.343-2.155 4.645-3.2 6.956-3.56c1.425-.224 2.854-.187 4.297.01M.824 5.799a13.64 13.64 0 0 0 6.812-.9c1.75-.706 3.127-1.68 3.944-2.569" />
                          <path d="M4.24 1.199a13.9 13.9 0 0 1 3.396 3.7c.563.901.987 1.819 1.298 2.715c.692 1.995.82 3.885.65 5.25" />
                        </g>
                      </svg>
                    </a>
                  )}
                  {p?.frontLinkGit && p?.frontLinkGit && (
                    <a
                      href={p.frontLinkGit}
                      target="_blank"
                      className={`${
                        !p.backLinkGit && "w-full"
                      } md:px-4 px-[10px] py-2.5 rounded-lg border border-slate-700 inline-block border-violet-400/20 bg-slate-500/10 flex gap-2 justify-center items-center hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1]`}
                    >
                      <span>Frontend</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        >
                          <path d="M9.096 21.25v-3.146a3.33 3.33 0 0 1 .758-2.115c-3.005-.4-5.28-1.859-5.28-5.798c0-1.666 1.432-3.89 1.432-3.89c-.514-1.13-.5-3.084.06-3.551c0 0 1.95.175 3.847 1.75c1.838-.495 3.764-.554 5.661 0c1.897-1.575 3.848-1.75 3.848-1.75c.558.467.573 2.422.06 3.551c0 0 1.432 2.224 1.432 3.89c0 3.94-2.276 5.398-5.28 5.798a3.33 3.33 0 0 1 .757 2.115v3.146" />
                          <path d="M3.086 16.57c.163.554.463 1.066.878 1.496c.414.431.932.77 1.513.988a4.46 4.46 0 0 0 3.62-.216" />
                        </g>
                      </svg>
                    </a>
                  )}
                  {p?.backLinkGit && p?.backLinkGit && (
                    <a
                      href={p.backLinkGit}
                      target="_blank"
                      className="md:px-4 px-[12px] py-2.5 rounded-lg border flex items-center justify-center gap-2 border-slate-700 inline-block border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1]"
                    >
                      <span>Backend</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        >
                          <path d="M9.096 21.25v-3.146a3.33 3.33 0 0 1 .758-2.115c-3.005-.4-5.28-1.859-5.28-5.798c0-1.666 1.432-3.89 1.432-3.89c-.514-1.13-.5-3.084.06-3.551c0 0 1.95.175 3.847 1.75c1.838-.495 3.764-.554 5.661 0c1.897-1.575 3.848-1.75 3.848-1.75c.558.467.573 2.422.06 3.551c0 0 1.432 2.224 1.432 3.89c0 3.94-2.276 5.398-5.28 5.798a3.33 3.33 0 0 1 .757 2.115v3.146" />
                          <path d="M3.086 16.57c.163.554.463 1.066.878 1.496c.414.431.932.77 1.513.988a4.46 4.46 0 0 0 3.62-.216" />
                        </g>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/*-------------EXPLORE MORE PROJECT BUTTON----- */}
      <div className="w-full flex justify-center">
        {selectedCategory == "all" && (
          <Link
            to="/project/all"
            className="mt-4 w-full md:w-[400px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE] text-center flex items-center justify-center bg-slate-500/10 hover:bg-blue-700/80 text-[18px]"
          >
            Explore More Projects
            <span className="inline-block ml-1"> &#8594;</span>
          </Link>
        )}
        {selectedCategory == "uiux" && (
          <Link
            to="/project/uiux"
            className="mt-4 w-full md:w-[400px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE] text-center flex items-center justify-center bg-slate-500/10 hover:bg-blue-700/80 text-[18px]"
          >
            Explore More UI/UX Projects
            <span className="inline-block ml-1"> &#8594;</span>
          </Link>
        )}
        {selectedCategory == "frontend" && (
          <Link
            to="/project/development"
            className="mt-4 w-full md:w-[400px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE] text-center flex items-center justify-center bg-slate-500/10 hover:bg-blue-700/80  text-[18px]"
          >
            Explore More Development Projects
            <span className="inline-block ml-1"> &#8594;</span>
          </Link>
        )}
        {selectedCategory == "frontend" ||
          (selectedCategory == "fullstack" && (
            <Link
              to="/project/development"
              className="mt-4 w-full md:w-[400px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE] text-center flex items-center justify-center bg-slate-500/10 hover:bg-blue-700/80  text-[18px]"
            >
              Explore More Development Projects
              <span className="inline-block ml-1"> &#8594;</span>
            </Link>
          ))}
      </div>
    </section>
  );
}
